import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { patientsApi } from '../api/patientsApi';

export function useProducerOutputs(id: number | null | undefined) {
  return useQuery({
    queryKey: keys.patient.outputs(id ?? 0),
    queryFn: ({ signal }) => patientsApi.getProducerOutputs(id!, { signal }),
    enabled: id != null,
    staleTime: 300_000,
  });
}
